import React from "react";
import { Repeat, Phone } from "react-feather";

function ChatHeader({ name, canTransfer, onTransferClick, showPhone, onPhoneClick }) {
  return (
    <div className="header author border-bottom justify-content-between">
      <span>{name}</span>

      <div className="d-flex flex-row align-center position-relative">
        {canTransfer && (
          <button className="action-btn mr-20" onClick={onTransferClick}>
            <Repeat />
          </button>
        )}

        {showPhone && (
          <button className="action-btn" onClick={onPhoneClick}>
            <Phone />
          </button>
        )}
      </div>
    </div>
  );
}

export default ChatHeader;

